module.exports = require('./helpers/bundle-url').getBundleURL('d6OmZ') + "logo.c51670a8.svg";